import { useTranslation } from 'react-i18next';
import { booksSchema } from './../../../../constants/booksConstant';

const TextbookTopic = ({ value }) => {
    const { t } = useTranslation();

    const key = booksSchema[value];

    if (!key) return '-';

    if (value === '1' || value === '2') { 
        return `${t(`books.${key}`)} ${value}`;
    }

    return t(`books.${key}`);
};

export default TextbookTopic;
